import { createFileRoute } from '@tanstack/react-router'
import { OrganisationSettingsPage } from '@/features/settings/components/organisation-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/organisation',
)({
  component: OrganisationSettingsPage,
  beforeLoad: async () => {
    return {
      title: 'Organisation',
      headerTitleKey: 'header.organisation.title',
      headerDescriptionKey: 'header.organisation.description',
    }
  },
})
